<template>
  <div class="generalPage">
    <isotopegrid v-bind:isotopeProps="isotopeProps"></isotopegrid>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isotopeProps: {
        title: '預防小貼士',
        desc: '了解預防小貼士',
        cardname: '預防小貼士',
        showTag: true,
        list: [{
          name: '預防曱甴',
          id: 0,
          imgpath: require('../assets/grid-ptips-roach.jpg'),
          link: '/preventiontips/tips/roach',
          tag: '曱甴'
        }, {
          name: '預防螞蟻',
          id: 1,
          imgpath: require('../assets/grid-ptips-ant.jpg'),
          link: '/preventiontips/tips/ant',
          tag: '螞蟻'
        }, {
          name: '預防一般昆蟲',
          id: 2,
          imgpath: require('../assets/grid-ptips-general.jpg'),
          link: '/preventiontips/tips/general',
          tag: ''
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function () {
              return true
            },
            '螞蟻': function (el) {
              return el.tag.match(/螞蟻$/)
            },
            '曱甴': function (el) {
              return el.tag.match(/曱甴$/)
            }
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>



// WEBPACK FOOTER //
// PTipsTips.vue?1cf9b3a8